import { Controller } from "@hotwired/stimulus";
import { Dropdown } from "bootstrap";

export default class extends Controller {
  static targets = ["submitOnChange", "submitOnDropdownHide"];

  submitOnChangeTargetConnected(target) {
    target.addEventListener("change", () => {
      this.element.requestSubmit();
    });
  }

  submitOnDropdownHideTargetConnected(target) {
    target.addEventListener("hide.bs.dropdown", () => {
      this.element.requestSubmit();
    });
  }

  connect() {
    this.element
      .querySelectorAll('input[type="radio"]')
      .forEach((radioElement) => {
        radioElement.addEventListener("change", () => {
          this.element.requestSubmit();
        });
      });
  }

  removeEmptyFields(event) {
    // Removes all fields that are empty from the form data
    const formData = event.formData;
    for (const key of Array.from(formData.keys())) {
      if (formData.get(key) == "") {
        formData.delete(key);
      }
    }
  }

  hideDropdown(event) {
    console.debug(event);
    const dropdownElement = event.target
      .closest(".dropdown")
      .querySelector('[data-bs-toggle="dropdown"]');
    if (!dropdownElement) {
      console.error("Development error - failed to find dropdown Element");
      return;
    }
    const dropdownInstance = Dropdown.getInstance(dropdownElement);
    if (!dropdownInstance) {
      console.error(
        "Development error - failed to find Dropdown instance on ",
        dropdownElement,
      );
      return;
    }
    dropdownInstance.hide();
  }
}
